"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.reduce(function (acc, entry) {
        if (entry.constructor === Object) {
            return acc.concat(Object.entries(entry).map(function (_a) {
                var key = _a[0], val = _a[1];
                return !!val ? key : null;
            }));
        }
        return acc.concat(entry ? entry : null);
    }, [])
        .filter(function (currentClass) { return !!currentClass; })
        .join(' ')
        .trim();
});
//# sourceMappingURL=index.js.map